import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { PureRender } from 'utils/component-helpers';
import FormResponsesAggregation from 'retired/FormResponsesAggregation';

const FormAggregationsOverlay = ({ toggleAction, visible, responsesAggregation }) => (
  <Dialog open={visible} onClose={() => toggleAction(null)} fullWidth maxWidth="md">
    <DialogTitle>Summary of additional questions responses</DialogTitle>
    <DialogContent>
      <FormResponsesAggregation responsesAggregation={responsesAggregation} />
    </DialogContent>
    <DialogActions>
      <Button color="primary" onClick={() => toggleAction(false)}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

FormAggregationsOverlay.propTypes = {
  visible: PropTypes.bool,
  responsesAggregation: PropTypes.array,
  toggleAction: PropTypes.func,
};

export default PureRender(FormAggregationsOverlay);
